// A tablet's camera as a scanner (UC-CATALOGUE-004 A8): a photo from the rear camera — the file input with `capture`, as the
// documents screen takes one (PAT-26) — read by the platform's barcode detector into the code a USB scanner would type.
// Nothing leaves the device; a device without the detector says so and the code is typed.

/** A tablet or phone — a touch screen — whose camera a file input with `capture` opens. A desk computer has none. */
export const touchDevice = (): boolean => typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia("(any-pointer: coarse)").matches;

interface DetectedBarcode { rawValue: string }
interface BarcodeDetectorLike { detect(source: Blob | ImageBitmap): Promise<DetectedBarcode[]> }
type DetectorConstructor = new (options?: { formats?: string[] }) => BarcodeDetectorLike;

/** The symbologies the practice's labels and its suppliers' boxes carry (BR-CATALOGUE-013): EAN-13, UPC-A, Code 128. */
const FORMATS = ["ean_13", "upc_a", "code_128", "ean_8", "upc_e", "code_39"];

/** The first code read from a photo, or null when none is; throws when the device has no barcode detector. */
export async function decodeBarcodePhoto(photo: Blob): Promise<string | null> {
  const Detector = (globalThis as { BarcodeDetector?: DetectorConstructor }).BarcodeDetector;
  if (!Detector) throw new Error("Its browser has no barcode reader.");
  let detector: BarcodeDetectorLike;
  try { detector = new Detector({ formats: FORMATS }); } catch { detector = new Detector(); }
  let source: Blob | ImageBitmap = photo;
  if (typeof createImageBitmap === "function") { try { source = await createImageBitmap(photo); } catch { source = photo; } }
  const found = await detector.detect(source);
  const code = found.find((b) => b.rawValue.trim() !== "")?.rawValue.trim();
  return code ?? null;
}
